import {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

import {TALK_VERSION} from '@zzng/common/constants/talkVersion';
import {isKakaoTalk, isValidTalkVersion, kakaoTalkVersion} from '@zzng/common/utils/agent';

import HeadlineCTemplate from '@/root/components/CardTemplate/templates/HeadlineCTemplate';
import PoketmonTemplate from '@/root/components/CardTemplate/templates/PoketmonTemplate';
import {ROUTES} from '@/root/constants/routes';
import {HeadlineDoorkeyTemplateProps} from '@/root/models/card';

const HeadlineDoorkeyTemplate = ({doorKey, ...props}: HeadlineDoorkeyTemplateProps) => {
  const navigate = useNavigate();
  const {groupCode} = useParams();

  useEffect(() => {
    // 브라우저에서 테스트하기 위함
    if (!isKakaoTalk) return;

    // 네이티브뷰에서 웹뷰로 전환되면서 구버전 유저가 도어키를 사용할 수 없기 때문에 강제로 업데이트 페이지로 이동
    if (!isValidTalkVersion(kakaoTalkVersion, TALK_VERSION['25.3.0'])) {
      navigate(ROUTES.INVALID_VERSION);
    }

    window.digitalCard?.applyDoorKey?.(JSON.stringify(doorKey));
  }, []);

  if (groupCode === 'KREW') {
    return (
      <PoketmonTemplate>
        <HeadlineCTemplate {...props} />
      </PoketmonTemplate>
    );
  }

  // HEADLINE_DOORKEY 템플릿은 HEADLINE_C 템플릿 디자인을 사용
  return <HeadlineCTemplate {...props} />;
};
export default HeadlineDoorkeyTemplate;
